import { DecimalPipe } from '@angular/common';
import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { SettingsService } from 'src/app/services/settings.service';

@Pipe({
    name: 'number',
    pure: false,
    standalone: false
})
export class LocalizedNumberPipe extends DecimalPipe implements PipeTransform {
  constructor(
    private settingsService: SettingsService,
    @Inject(LOCALE_ID) locale: string
  ) {
    super(locale);
  }

  transform(value: any, pattern: string): any {
    try {
      const decimalFormat = this.settingsService.get().decimalFormat;
      return super.transform(value, pattern, decimalFormat);
    } catch {}
    // settings hold an unregistered locale (e.g. the old '1-2.2' default or
    // 'en_GB') — fall back to the app locale instead of returning the raw value
    try {
      return super.transform(value, pattern);
    } catch {}
    return value;
  }
}
